/** FR label for a plugin error severity. */
export function severityLabel(s: string): string {
  switch (s) {
    case "error":
      return "Erreur";
    case "warning":
      return "Avertissement";
    case "transient":
      return "Transitoire";
    default:
      return s;
  }
}
